import React, { useCallback, useRef, useState } from "react";
import Webcam from "react-webcam";





function dataURLtoFile(dataurl, filename) {
 
  var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), 
      n = bstr.length, 
      u8arr = new Uint8Array(n);
      
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  
  return new File([u8arr], filename, {type:mime});
}

function WebcamImage() {
  const [img, setImg] = useState(null);
  const webcamRef = useRef(null);
  const [file, setFile] = useState(null);



 

  const videoConstraints = {
    width: 420,
    height: 420,
    facingMode: "user",
  };

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImg(imageSrc);
    // console.log(imageSrc)
    // const base64 = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD//'
    const files = dataURLtoFile(imageSrc,'hello');
   
  setFile(files);
   
  }, [webcamRef]
 
  
  );
//console.log(file);
  return (
    {file},
    <div className="Container">
  <p>dfsgfdgfd</p>


      {img === null ? (
        <>

          <Webcam
            audio={false}
            mirrored={true}
            height={400}
            width={400}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            videoConstraints={videoConstraints}
          />
          <button onClick={capture}>Capture photo</button>
        </>
      ) : (
        <>

        <p>dfsgfdgfd</p>
          <img src={img} alt="screenshot" />
          <button onClick={() => setImg(null)}>Retake</button>
          <img src={file} alt="screenshot" />
         


        </>
      )}


    </div>
    
  );
}
//https://blog.openreplay.com/capture-real-time-images-and-videos-with-react-webcam/ ข้อมูลเพิ่่มเดิม
export default WebcamImage;